// The one thing inline styles cannot say: the alarm pulse (STAGE_4 4.5, as in the
// prototype). Without motion for those who asked the system for less of it.

const CSS = `
@keyframes sos-alarm-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(229, 72, 77, 0); }
  50% { box-shadow: 0 0 0 4px rgba(229, 72, 77, 0.35); }
}
.sos-alarm-pulse { animation: sos-alarm-pulse 1.2s ease-in-out infinite; }
@media (prefers-reduced-motion: reduce) {
  .sos-alarm-pulse { animation: none; box-shadow: 0 0 0 2px rgba(229, 72, 77, 0.8); }
}
`;

export function DeskStyles() {
  return <style>{CSS}</style>;
}
